<template>
  <div>
    <div class="">
      <!--
<div class="relative ...">



      <button type="button" @click="isOpen = !isOpen" class="...">
      Options
    </button>
      <transition
        enter-active-class="transition duration-100 ease-out transform"
        enter-class="scale-95 opacity-0"
        enter-to-class="scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in transform"
        leave-class="scale-100 opacity-100"
        leave-to-class="scale-95 opacity-0"
      >
        <div v-show="isOpen" class="absolute right-0 w-56 mt-2 origin-top-right rounded-md shadow-lg">
          <div class="bg-white rounded-md shadow-xs">
            <ul>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
              <li>aaa</li>
            </ul>
          </div>
        </div>
      </transition>
      
  </div>
  -->

      <div class="px-4">
        <div class="-mx-4 lg:flex">
          <div
            class="px-2 py-2 bg-white shadow sm:rounded-md sm:px-6 -top-6 lg:hidden"
          >
            <div
              class="flex flex-wrap items-end justify-between sm:flex-no-wrap"
            >
              <div class="">
                <h3 class="text-lg font-medium leading-6 text-gray-900">
                  {{ menu.name }}
                </h3>
                <p class="mt-1 text-xs text-sm leading-5 text-gray-500">
                  Seleziona/deseleziona i prodotti per inserirli/toglierli
                </p>
              </div>

              <div class="flex mt-2" v-if="showActions">
                <span class="inline-flex rounded-md shadow-sm">
                  <router-link
                    :to="{
                      name: 'Menu',
                      params: { id: this.id, idmenu: this.idmenu },
                    }"
                    type="button"
                    class="relative inline-flex items-center px-2 py-2 mr-1 text-sm font-medium leading-5 text-white bg-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                  >
                    <svg
                      class="inline-block w-5 h-5 text-white fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M500.633 211.454l-58.729-14.443a193.856 193.856 0 00-13.55-32.256c8.818-14.678 27.349-45.571 27.349-45.571a15.001 15.001 0 00-2.256-18.325l-42.422-42.422a14.958 14.958 0 00-18.325-2.256L347.055 83.53a193.24 193.24 0 00-32.065-13.433l-14.443-58.729A14.996 14.996 0 00286 0h-60c-6.885 0-12.891 4.688-14.546 11.367 0 0-10.005 40.99-14.429 58.715a192.571 192.571 0 00-34.043 14.502l-47.329-28.403c-5.918-3.516-13.447-2.607-18.325 2.256l-42.422 42.422a15.001 15.001 0 00-2.256 18.325l29.268 48.882a193.296 193.296 0 00-11.821 28.901l-58.729 14.487A14.994 14.994 0 000 226v60c0 6.885 4.688 12.891 11.367 14.546l58.744 14.443c3.56 11.294 8.188 22.266 13.799 32.798l-26.191 43.652a15.001 15.001 0 002.256 18.325l42.422 42.422c4.849 4.849 12.407 5.771 18.325 2.256 0 0 29.37-17.607 43.755-26.221a193.254 193.254 0 0032.549 13.696l14.429 58.715C213.109 507.313 219.115 512 226 512h60a14.995 14.995 0 0014.546-11.367l14.429-58.715a190.535 190.535 0 0033.281-14.136c14.78 8.862 44.443 26.66 44.443 26.66 5.903 3.53 13.462 2.622 18.325-2.256l42.422-42.422a15.001 15.001 0 002.256-18.325l-26.968-44.927a192.1 192.1 0 0013.169-31.523l58.729-14.443A14.993 14.993 0 00512 286v-60a14.994 14.994 0 00-11.367-14.546zM256 361c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105z"
                      />
                    </svg>
                  </router-link>
                </span>

                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    @click="print"
                    type="button"
                    class="relative inline-flex items-center px-2 py-2 mr-1 text-sm font-medium leading-5 text-white bg-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                  >
                    <svg
                      class="inline-block w-5 h-5 text-white fill-current"
                      viewBox="0 0 512 512"
                      height="512"
                      width="512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        data-name="Tracciato 1"
                        d="M118.137 293.088c0-6.835-4.742-10.91-13.11-10.91a29.026 29.026 0 00-6.941.66v21.928a26.3 26.3 0 005.623.43c8.919 0 14.428-4.506 14.428-12.108z"
                      />
                      <path
                        data-name="Tracciato 2"
                        d="M208.369 291.494a34.615 34.615 0 00-7.6.659v48.56a30.384 30.384 0 005.839.336c15.2.108 25.115-8.26 25.115-25.99.107-15.413-8.927-23.565-23.354-23.565z"
                      />
                      <path
                        data-name="Tracciato 3"
                        d="M353.329 0H101.218C64.387 0 34.411 29.494 34.411 65.686l-.965 137.734h-6.525A26.694 26.694 0 000 229.89v160.522a26.692 26.692 0 0026.921 26.464h6.525v29.435c0 36.232 29.976 65.685 66.807 65.685h343.994c36.808 0 66.788-29.455 66.788-65.685L512 155.457zm-282.7 258.858c7.89-1.311 18.979-2.3 34.6-2.3 15.79 0 27.043 2.963 34.6 8.916a32.329 32.329 0 0112.1 25.763c0 10.893-3.694 20.154-10.414 26.428-8.741 8.09-21.668 11.721-36.789 11.721a67.423 67.423 0 01-8.741-.485v39.8h-25.36zm373.618 212.918H100.253a25.7 25.7 0 01-25.874-25.459v-29.441h320.673a26.692 26.692 0 0026.922-26.468V229.889a26.694 26.694 0 00-26.922-26.47H74.379l.965-137.734a25.693 25.693 0 0125.874-25.419l236.8-.243v86.061c0 25.138 20.745 45.553 46.331 45.553l85.746-.242v274.918a25.682 25.682 0 01-25.848 25.463zM168.283 368.202V258.858a234.459 234.459 0 0134.6-2.3c21.5 0 35.446 3.793 46.371 11.881 11.758 8.594 19.143 22.293 19.143 41.961 0 21.3-7.89 36.011-18.816 45.088-11.922 9.744-30.069 14.365-52.239 14.365a225.378 225.378 0 01-29.059-1.651zm183.344-64.738v20.476h-40.659v44.766h-25.7v-111.32h69.209v20.637h-43.51v25.441z"
                      />
                    </svg>
                  </button>
                </span>
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    @click="saveMenuCompose"
                    type="button"
                    class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                  >
                    Salva
                  </button>
                </span>
              </div>
            </div>
          </div>

          <div class="w-full lg:px-4 lg:w-1/3 ">
            <div class="sticky top-0">
              <div
                class="overflow-y-auto text-base lg:text-sm sticky?lg:h-(screen-16)"
              >
                <div class="">
                  <div class="sticky top-0 z-10 ">
                    <div class="relative ">
                      <div
                        class="bg-gray-100 border-t-2 border-b-4 border-gray-100 lg:mr-2"
                      >
                        <div
                          class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                        >
                          <svg
                            class="w-5 h-5 text-gray-400"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path
                              class="heroicon-ui"
                              d="M16.32 14.9l5.39 5.4a1 1 0 01-1.42 1.4l-5.38-5.38a8 8 0 111.41-1.41zM10 16a6 6 0 100-12 6 6 0 000 12z"
                            />
                          </svg>
                        </div>
                        <input
                          v-model="search"
                          class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                          placeholder="Cerca"
                        />
                      </div>
                    </div>
                  </div>
                  <ul class="mt-4">
                    <li v-for="category in filterCategory" :key="category.id">
                      <div class="relative">
                        <div class="flex items-start">
                          <div class="absolute flex items-center h-5">
                            <input
                              v-on:change="toogleAllCheckBox($event, category)"
                              :id="'selectall_' + category.id"
                              type="checkbox"
                              class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                            />
                          </div>
                          <div
                            class="mt-0.5 text-sm font-bold leading-5 tracking-wide text-gray-500 uppercase pl-6 lg:mb-2 lg:text-xs"
                          >
                            <label
                              title="Aggiungi tutti"
                              :for="'selectall_' + category.id"
                              class=""
                              >{{ category.name }}
                            </label>
                          </div>
                        </div>
                      </div>

                      <ul
                        class="p-4 mb-4 bg-white shadow lg:mr-2 sm:rounded-md"
                      >
                        <li
                          v-for="dish in category.dishes"
                          :key="dish.id"
                          class="relative mb-1"
                        >
                          <div class="flex items-start">
                            <div class="absolute flex items-center h-5">
                              <input
                                v-on:change="
                                  changeCheckBox($event, category, dish)
                                "
                                :id="'list_dish_' + dish.id"
                                v-model="checkedDishes"
                                :value="dish.id"
                                type="checkbox"
                                class="w-4 h-4 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                              />
                            </div>
                            <div class="text-sm leading-5 pl-7">
                              <label
                                :for="'list_dish_' + dish.id"
                                class="font-normal text-gray-700"
                                >{{ dish.name }}
                              </label>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full lg:px-4 lg:pb-4 lg:min-h-screen lg:w-2/3">
            <div
              class="sticky hidden px-4 py-5 bg-white shadow sm:rounded-md sm:px-6 -top-6 lg:block"
            >
              <div
                class="flex flex-wrap items-end justify-between -mt-4 -ml-4 sm:flex-no-wrap"
              >
                <div class="mt-4 ml-4">
                  <h3 class="text-lg font-medium leading-6 text-gray-900">
                    {{ menu.name }}
                  </h3>
                  <p class="mt-1 text-sm leading-5 text-gray-500">
                    Seleziona / deseleziona i piatti per inserirli / toglierli
                    dal menu. Ordina le categorie e i piatti del menu
                    trascinandoli. Puoi modificare lo stile (colori, icone,
                    font) nella
                    <router-link
                      class="font-medium text-indigo-700"
                      :to="{ name: 'Location', params: { id: this.id } }"
                      >sezione Location</router-link
                    >.
                  </p>
                </div>

                <div class="flex mt-4 ml-2" v-if="showActions">
                  <span class="inline-flex rounded-md shadow-sm">
                    <router-link
                      :to="{
                        name: 'Menu',
                        params: { id: this.id, idmenu: this.idmenu },
                      }"
                      type="button"
                      class="relative inline-flex items-center px-2 py-2 mr-1 text-sm font-medium leading-5 text-white bg-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                    >
                      <svg
                        class="inline-block w-5 h-5 text-white fill-current"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M500.633 211.454l-58.729-14.443a193.856 193.856 0 00-13.55-32.256c8.818-14.678 27.349-45.571 27.349-45.571a15.001 15.001 0 00-2.256-18.325l-42.422-42.422a14.958 14.958 0 00-18.325-2.256L347.055 83.53a193.24 193.24 0 00-32.065-13.433l-14.443-58.729A14.996 14.996 0 00286 0h-60c-6.885 0-12.891 4.688-14.546 11.367 0 0-10.005 40.99-14.429 58.715a192.571 192.571 0 00-34.043 14.502l-47.329-28.403c-5.918-3.516-13.447-2.607-18.325 2.256l-42.422 42.422a15.001 15.001 0 00-2.256 18.325l29.268 48.882a193.296 193.296 0 00-11.821 28.901l-58.729 14.487A14.994 14.994 0 000 226v60c0 6.885 4.688 12.891 11.367 14.546l58.744 14.443c3.56 11.294 8.188 22.266 13.799 32.798l-26.191 43.652a15.001 15.001 0 002.256 18.325l42.422 42.422c4.849 4.849 12.407 5.771 18.325 2.256 0 0 29.37-17.607 43.755-26.221a193.254 193.254 0 0032.549 13.696l14.429 58.715C213.109 507.313 219.115 512 226 512h60a14.995 14.995 0 0014.546-11.367l14.429-58.715a190.535 190.535 0 0033.281-14.136c14.78 8.862 44.443 26.66 44.443 26.66 5.903 3.53 13.462 2.622 18.325-2.256l42.422-42.422a15.001 15.001 0 002.256-18.325l-26.968-44.927a192.1 192.1 0 0013.169-31.523l58.729-14.443A14.993 14.993 0 00512 286v-60a14.994 14.994 0 00-11.367-14.546zM256 361c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105z"
                        />
                      </svg>
                    </router-link>
                  </span>

                  <span class="inline-flex rounded-md shadow-sm">
                    <button
                      @click="print"
                      type="button"
                      class="relative inline-flex items-center px-2 py-2 mr-1 text-sm font-medium leading-5 text-white bg-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                    >
                      <svg
                        class="inline-block w-5 h-5 text-white fill-current"
                        viewBox="0 0 512 512"
                        height="512"
                        width="512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          data-name="Tracciato 1"
                          d="M118.137 293.088c0-6.835-4.742-10.91-13.11-10.91a29.026 29.026 0 00-6.941.66v21.928a26.3 26.3 0 005.623.43c8.919 0 14.428-4.506 14.428-12.108z"
                        />
                        <path
                          data-name="Tracciato 2"
                          d="M208.369 291.494a34.615 34.615 0 00-7.6.659v48.56a30.384 30.384 0 005.839.336c15.2.108 25.115-8.26 25.115-25.99.107-15.413-8.927-23.565-23.354-23.565z"
                        />
                        <path
                          data-name="Tracciato 3"
                          d="M353.329 0H101.218C64.387 0 34.411 29.494 34.411 65.686l-.965 137.734h-6.525A26.694 26.694 0 000 229.89v160.522a26.692 26.692 0 0026.921 26.464h6.525v29.435c0 36.232 29.976 65.685 66.807 65.685h343.994c36.808 0 66.788-29.455 66.788-65.685L512 155.457zm-282.7 258.858c7.89-1.311 18.979-2.3 34.6-2.3 15.79 0 27.043 2.963 34.6 8.916a32.329 32.329 0 0112.1 25.763c0 10.893-3.694 20.154-10.414 26.428-8.741 8.09-21.668 11.721-36.789 11.721a67.423 67.423 0 01-8.741-.485v39.8h-25.36zm373.618 212.918H100.253a25.7 25.7 0 01-25.874-25.459v-29.441h320.673a26.692 26.692 0 0026.922-26.468V229.889a26.694 26.694 0 00-26.922-26.47H74.379l.965-137.734a25.693 25.693 0 0125.874-25.419l236.8-.243v86.061c0 25.138 20.745 45.553 46.331 45.553l85.746-.242v274.918a25.682 25.682 0 01-25.848 25.463zM168.283 368.202V258.858a234.459 234.459 0 0134.6-2.3c21.5 0 35.446 3.793 46.371 11.881 11.758 8.594 19.143 22.293 19.143 41.961 0 21.3-7.89 36.011-18.816 45.088-11.922 9.744-30.069 14.365-52.239 14.365a225.378 225.378 0 01-29.059-1.651zm183.344-64.738v20.476h-40.659v44.766h-25.7v-111.32h69.209v20.637h-43.51v25.441z"
                        />
                      </svg>
                    </button>
                  </span>
                  <span class="inline-flex rounded-md shadow-sm">
                    <button
                      @click="saveMenuCompose"
                      type="button"
                      class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                    >
                      Salva
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <ul id="menulist" ref="menulist">
              <draggable
                :options="options"
                v-model="categoriesSelected"
                :group="'parent_' + categoriesSelected.id"
                @start="drag = true"
                @end="drag = false"
              >
                <li
                  v-for="categorySel in categoriesSelected"
                  :key="categorySel.id"
                  class="px-4 py-5 mt-4 bg-white shadow sm:rounded-md sm:px-6"
                >
                  <div class="flex items-end">
                    <img
                      v-if="categorySel.url != null"
                      :src="getCategoryIcon(categorySel.url)"
                      class="inline-block w-5 h-5"
                      :alt="categorySel.name"
                    />
                    <!--
                  <div  v-if="categorySel.url != null && categorySel.url != ''">
                     :data="getPathIcon(categorySel.icon)" 
                    <object @load="onLoad($event)"  :data="categorySel.url" class="inline-block w-5 h-5" ></object>

                  </div>
                  -->
                    <h3
                      class="ml-2 text-sm font-bold leading-none tracking-wide text-gray-500 uppercase lg:text-xs"
                      :class="'text-' + locationColor.primary"
                    >
                      {{ categorySel.name }}
                    </h3>
                  </div>

                  <hr
                    class="mt-2 "
                    :class="'border-' + locationColor.primary"
                  />
                  <ul>
                    <draggable
                      :options="options"
                      v-model="categorySel.dishes"
                      :group="categorySel.id"
                      @start="drag = true"
                      @end="drag = false"
                    >
                      <li
                        v-for="(dish, indexdish) in categorySel.dishes"
                        :key="dish.id"
                      >
                        <div class="flex justify-between py-1.5">
                          <div>
                            <p>
                              <router-link
                                :to="{
                                  name: 'Dish',
                                  params: { id: id, iddish: dish.id },
                                }"
                                class="flex items-center "
                              >
                                <span class="hover:text-indigo-600"
                                  >{{ dish.name }}
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  class="w-3.5 h-3.5 mt-1"
                                >
                                  <path
                                    d="M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"
                                    class="heroicon-ui"
                                  ></path>
                                </svg>
                              </router-link>
                            </p>
                            <span
                              v-if="
                                dish.price != null &&
                                  dish.price != undefined &&
                                  dish.price != ''
                              "
                              class="inline-flex items-center px-2 text-xs font-medium leading-5 rounded-md"
                              :class="'text-' +
                                  locationColor.primary +
                                  ' bg-' +
                                  locationColor.secondary
                              "
                            >
                              {{ dish.price.toFixed(2) }} {{ dish.unit }}
                            </span>
                          </div>
                          <div>
                            <div
                              class="text-right"
                              v-if="dish.allergens != null"
                            >
                              <span
                                class="inline-flex items-center px-1.5 mr-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                                >Allergeni:</span
                              >
                              <span
                                v-for="allergy in getDishesAllergen(
                                  dish.allergens
                                )"
                                :key="dish.id + '_allergy_' + allergy.id"
                              >
                                <img
                                  :title="allergy.name"
                                  :src="
                                    getIconAllergen(
                                      allergy.icon,
                                      locationIconStyle
                                    )
                                  "
                                  class="inline-block w-5 h-5 mr-2"
                                />
                              </span>
                            </div>
                            <div class="h-1"></div>
                            <div class="text-right">
                              <div class="" v-if="dish.attributes != null">
                                <span
                                  v-for="attribute in getDishesAttribute(
                                    dish.attributes
                                  )"
                                  :key="'allergy' + attribute.id"
                                >
                                  <img
                                    :title="attribute.name"
                                    :src="
                                      getIconAttribute(
                                        attribute.icon,
                                        locationIconStyle
                                      )
                                    "
                                    class="inline-block w-5 h-5 mr-2"
                                  />
                                </span>
                              </div>
                            </div>

                            <!--
                        <div class="text-right" v-if="dish.checked_allergies.length>0">
                          <span class="inline-flex items-center px-1.5 mr-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">Allergeni:</span>
                          <span v-for="allergy in dish.checked_allergies" :key="dish.id+'_allergy_'+allergy.id" >
                            
                            <img :title="allergy.name" :src="getIconAllergen(allergy.icon, locationIconStyle)" class="inline-block w-5 h-5 mr-2" >
                                                     

                          </span>
                        </div>
                          <div class="text-right">
                          <span v-for="attribute in dish.checked_attributes" :key="'allergy'+attribute.id" >
                            <img :title="attribute.name" :src="getIconAttribute(attribute.icon, locationIconStyle)" class="inline-block w-5 h-5 mr-2" >
                          </span>
                        </div>
                        -->
                          </div>
                        </div>

                        <hr
                          v-if="indexdish < categorySel.dishes.length - 1"
                          :class="'border-dotted border-' + locationColor.primary
                          "
                        />
                      </li>
                    </draggable>
                  </ul>
                </li>
              </draggable>
            </ul>

            <div v-if="showEmpty">
              <div
                class="inline-block min-w-full p-5 mt-4 overflow-hidden text-center align-middle bg-white shadow sm:rounded-md"
              >
                <div class="mx-auto">
                  <div
                    class="flex items-center justify-center flex-shrink-0 mx-auto rounded-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 286.001 286"
                      class="w-12 h-12"
                    >
                      <defs>
                        <linearGradient
                          id="dishesb"
                          x1=".089"
                          y1=".068"
                          x2=".908"
                          y2=".94"
                          gradientUnits="objectBoundingBox"
                        >
                          <stop offset="0" stop-color="#71ff9c"></stop>
                          <stop offset=".309" stop-color="#3bdcaa"></stop>
                          <stop offset="1" stop-color="#04b8b8"></stop>
                        </linearGradient>
                        <filter
                          id="dishesa"
                          x="0"
                          y="0"
                          width="286.001"
                          height="286"
                          filterUnits="userSpaceOnUse"
                        >
                          <feOffset dx="8" dy="15"></feOffset>
                          <feGaussianBlur
                            stdDeviation="5"
                            result="blur"
                          ></feGaussianBlur>
                          <feFlood flood-opacity=".161"></feFlood>
                          <feComposite operator="in" in2="blur"></feComposite>
                          <feComposite in="SourceGraphic"></feComposite>
                        </filter>
                      </defs>
                      <g filter="url(#dishesa)">
                        <path
                          data-name="dasch_cappello2"
                          d="M233 256H23a23 23 0 01-23-23V23A23 23 0 0123 0h210a23 23 0 0123 23v210a23 23 0 01-23 23zM80.055 173.255a3.222 3.222 0 00-3.215 3.212l-.013 9.373a13.118 13.118 0 0013.117 13.132h76.625a13.131 13.131 0 0013.116-13.116v-9.386a3.218 3.218 0 00-3.215-3.215zM85.12 71.439a3.234 3.234 0 00-.77.093 35.274 35.274 0 00-7.459 65.728l-.035 26.348a3.249 3.249 0 00.94 2.276 3.205 3.205 0 002.275.941h96.4a3.218 3.218 0 003.215-3.215v-26.4a35.341 35.341 0 00-16.073-66.827 33.2 33.2 0 00-6.132.6A38.545 38.545 0 0089.674 96.1a3.215 3.215 0 01-6.43 0A44.4 44.4 0 0188 76.091a3.212 3.212 0 00-2.884-4.652zm68.848 76.1a3.215 3.215 0 01-2.486-5.252c3.447-4.21 8.915-12.617 8.915-17.251a3.215 3.215 0 016.43 0c0 3.541-1.611 8.03-4.788 13.344a70.486 70.486 0 01-5.584 7.985 3.215 3.215 0 01-2.488 1.174zm-25.717 0a3.218 3.218 0 01-3.215-3.215v-19.289a3.215 3.215 0 016.43 0v19.289a3.218 3.218 0 01-3.216 3.215zm-25.714 0a3.218 3.218 0 01-2.489-1.174 70.485 70.485 0 01-5.584-7.985c-3.177-5.314-4.788-9.8-4.788-13.344a3.215 3.215 0 016.43 0c0 4.651 5.468 13.047 8.915 17.248a3.216 3.216 0 01-2.483 5.256z"
                          transform="translate(7)"
                          fill="url(#dishesb)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>

                <p class="mt-1 text-base">
                  Non sono presenti piatti, creane uno adesso!
                </p>

                <router-link
                  :to="{ name: 'Dishes', params: { id: this.id } }"
                  type="button"
                  class="relative inline-flex items-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                >
                  Crea nuovo piatto
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MenuService from "../apis/MenuService";
import IconService from "../apis/IconService";
import LocationService from "../apis/LocationService";
import draggable from "vuedraggable";
import jsPDF from "jspdf";
//import {Scricha} from '../fonts';
export default {
  props: {
    id: Number,
    idmenu: Number,
  },
  components: {
    draggable,
  },
  data() {
    return {
      options: {
        delay: 200,
        touchStartThreshold: 5,
        delayOnTouchOnly: true,
      },
      askSave: false,

      showActions: false,
      showEmpty: false,
      menu: {},
      isOpen: false,
      search: "",
      categories: [],
      categoriesSelected: [],
      checkedDishes: [],
      allergens: [],
      attributes: [],
      action: this.$route.meta.action,
      myArray: [],
      locationColor: {},
      locationIconStyle: 1,
      pdf: {
        font1: "",
        font2: "",
        showTitle: true,
        showLogo: true,
        showLocationName: true,
        positionY: 0,
        lineSpacing: 1.6,
        fontSizeCategoryName: 20,
        fontSizeDishName: 16,
        fontSizeDishDesc: 12,
        fontSizeDishAllergen: 8,
        fontSizeDishAttr: 8,
        marginX: 24,
        marginY: 10,
        betweenCategoriesSpace: 15,
        iconAllergenAttr: false,
      },
    };
  },
  mounted() {
    this.loadLocationConfig();

    /*
    MenuService.allergiesAttributes().then(response => {
      this.allergies = response.data.allergies;
      this.attributes = response.data.dish_attributes;
    });
    */

    MenuService.compose(this.id, this.idmenu).then((response) => {
      this.categories = response.data.data.categories;
      this.allergens = response.data.data.allergens;
      this.attributes = response.data.data.attributes;

      if (this.categories.length == 0) {
        this.showEmpty = true;
      }
    });

    MenuService.dishes(this.id, this.idmenu).then((response) => {
      this.categoriesSelected = response.data.data.categories;

      if (this.allergens.length == 0) {
        this.allergens = response.data.data.allergens;
      }

      if (this.attributes.length == 0) {
        this.attributes = response.data.data.attributes;
      }

      for (let i = 0; i < this.categoriesSelected.length; i++) {
        for (let j = 0; j < this.categoriesSelected[i].dishes.length; j++) {
          this.checkedDishes.push(this.categoriesSelected[i].dishes[j].id);
        }
      }

      this.showActions = true;
    });

    MenuService.getMenu(this.id, this.idmenu).then((response) => {
      this.menu = response.data.data;
    });
  },
  created() {},
  computed: {
    filterCategory: function() {
      //return this.categories.filter(d => d.dishes.every(c => c.name.includes(this.search)));
      let filteredResult = JSON.parse(JSON.stringify(this.categories));
      for (let i = 0; i < filteredResult.length; i++) {
        for (let j = filteredResult[i].dishes.length - 1; j >= 0; j--) {
          if (
            !filteredResult[i].dishes[j].name
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            filteredResult[i].dishes.splice(j, 1);
          }
        }
      }
      return filteredResult;
    },
  },
  methods: {
    getCategoryIcon: function(url) {
      return IconService.getIconCat(url);
    },

    loadLocationConfig: function() {
      let location = this.$store.getters.locationById(this.id);
      if (location.length == 1) {
        this.locationColor = location[0].color;
        this.locationIconStyle = location[0].icon_style_id;
      } else {
        LocationService.getLocation(this.id).then((response) => {
          this.locationColor = response.data.data.color;
          this.locationIconStyle = response.data.data.icon_style_id;
        });
      }
    },

    getIconAttribute: function(iconid, styleid) {
      return IconService.getIconAttribute(iconid, styleid);
    },

    getIconAllergen: function(iconid, styleid) {
      return IconService.getIconAllergen(iconid, styleid);
    },

    getDishesAllergen: function(al) {
      let list = al.split(",").map((i) => Number(i));
      if (this.allergens.length > 0)
        return this.allergens.filter((x) => list.includes(x.id));
    },

    getDishesAttribute: function(at) {
      let list = at.split(",").map((i) => Number(i));
      if (this.attributes.length > 0)
        return this.attributes.filter((x) => list.includes(x.id));
    },

    onLoad(event) {
      let content = event.target.contentDocument;
      if (content != null || content != undefined) {
        let svg = content.getElementsByTagName("svg")[0];
        svg.setAttribute("fill", "#5145cd");
      }
    },

    saveMenuCompose: function() {
      this.$store.dispatch("updateSpinner", true);
      MenuService.updateCompose(
        this.id,
        this.idmenu,
        this.categoriesSelected
      ).then((response) => {
        console.log(response);
        this.$store.dispatch("updateSpinner", false);
        this.$store.dispatch("addNotification", {
          id: Math.floor(Math.random() * 100000),
          title: "Menu salvato",
          description: "",
        });
      });
    },

    printDish(doc, category, dish) {
      doc.setFontType("normal");
      doc.setTextColor(0, 0, 0);

      let pageHeight = doc.internal.pageSize.height;
      let pageWidth = doc.internal.pageSize.width;
      let maxw = pageWidth - this.pdf.marginX * 2;
      //console.log(pageWidth, pageHeight);

      let deltaYCategoryName =
        (this.pdf.fontSizeCategoryName * this.pdf.lineSpacing * 25.4) / 72;
      let deltaYDishName =
        (this.pdf.fontSizeDishName * this.pdf.lineSpacing * 25.4) / 72;
      let deltaYDishDesc =
        (this.pdf.fontSizeDishDesc * this.pdf.lineSpacing * 25.4) / 72;
      let deltaYAllergen =
        (this.pdf.fontSizeDishAllergen * this.pdf.lineSpacing * 25.4) / 72;
      let deltaYAttr =
        (this.pdf.fontSizeDishAttr * this.pdf.lineSpacing * 25.4) / 72;

      let allergensH = dish.allergens ? deltaYAllergen : 0;
      let attributesH = dish.attributes ? deltaYAttr : 0;

      let categoryH =
        category != null
          ? deltaYCategoryName + this.pdf.betweenCategoriesSpace
          : 0;

      doc.setFontSize(this.pdf.fontSizeDishDesc);

      //**doc.setFont(this.pdf.font2);
      let textLines = [];

      if (dish.description != null) {
        textLines = doc.splitTextToSize(dish.description, maxw);
      }

      let totalH =
        this.pdf.marginY +
        categoryH +
        deltaYDishName +
        deltaYDishDesc * textLines.length +
        allergensH +
        attributesH;

      if (this.pdf.positionY + totalH >= pageHeight) {
        doc.addPage();
        this.pdf.positionY = this.pdf.marginY;
      } else if (category != null) {
        this.pdf.positionY += this.pdf.betweenCategoriesSpace; //?????oppure si può fare uguale a deltaYCategoryName
      }

      if (category != null) {
        this.pdf.positionY += deltaYCategoryName;
        //**doc.setFont(this.pdf.font1);
        doc.setFontSize(this.pdf.fontSizeCategoryName);
        doc.text(category.name, this.pdf.marginX, this.pdf.positionY);
      }

      this.pdf.positionY += deltaYDishName;
      doc.setFontSize(this.pdf.fontSizeDishName);
      //**doc.setFont(this.pdf.font1);
      doc.text(dish.name, this.pdf.marginX, this.pdf.positionY);

      if (
        dish.price &&
        this.menu.isEnableHidePrice == 0 &&
        this.menu.isEnableMenuHotel == 0
      ) {
        //doc.text(dish.price.toString()+" " + dish.unit, pageWidth - this.pdf.marginX,  this.pdf.positionY, null, null, "right");
        doc.text(
          dish.price.toFixed(2) + " " + dish.unit,
          pageWidth - this.pdf.marginX,
          this.pdf.positionY,
          null,
          null,
          "right"
        );
      }

      if (dish.description != null) {
        doc.setTextColor(50, 50, 50);

        doc.setFontSize(this.pdf.fontSizeDishDesc);
        //**doc.setFont(this.pdf.font2);
        textLines.forEach((lineText) => {
          this.pdf.positionY += deltaYDishDesc;
          doc.text(lineText, this.pdf.marginX, this.pdf.positionY);
        });
      }

      doc.setTextColor(100, 100, 100);

      if (dish.attributes) {
        this.pdf.positionY += deltaYAttr;
        doc.setFontSize(this.pdf.fontSizeDishAttr);
        let joinAttributes = "* ";
        let dishAttributes = this.getDishesAttribute(dish.attributes);
        for (let i = 0; i < dishAttributes.length; i++) {
          joinAttributes +=
            dishAttributes[i].name +
            (i < dishAttributes.length - 1 ? ", " : "");
        }
        doc.text(joinAttributes, this.pdf.marginX, this.pdf.positionY);
      }

      if (dish.allergens) {
        this.pdf.positionY += deltaYAllergen;
        doc.setFontSize(this.pdf.fontSizeDishAllergen);
        let joinAllergen = "Allergeni: ";
        let dishAllergens = this.getDishesAllergen(dish.allergens);
        for (let i = 0; i < dishAllergens.length; i++) {
          joinAllergen +=
            dishAllergens[i].name + (i < dishAllergens.length - 1 ? ", " : "");
        }
        doc.text(joinAllergen, this.pdf.marginX, this.pdf.positionY);
      }
    },

    print: async function() {
      let location = this.$store.getters.locationById(this.id);
      if (location.length != 1) {
        LocationService.getLocation(this.id).then((response) => {
          location = response.data.data.color;
        });
      }

      // eslint-disable-next-line no-unused-vars
      let pdfName = "menu";
      var doc = new jsPDF({ format: "a4" });

      /*let img = new Image();
      img.src = "https://static.menubyte.it/dc577554-fc21-44e9-a922-b2e3e94e883b/logo.png"
            console.log(location[0].logo);
*/

      //let img = await this.loadImage(location[0].logo)
      //doc.addImage(img, "PNG", 15, 40, img.width*0.2, img.height*0.2);

      /*
      // eslint-disable-next-line no-constant-condition
      if (1 == 2 - 1) {
        let {Scricha} = await import('../fonts/index');
        doc.addFileToVFS('Scricha.ttf', Scricha);
        doc.addFont('Scricha.ttf', 'Scricha', 'normal')
        this.pdf.font2 = 'Scricha';
      }

      // eslint-disable-next-line no-constant-condition
      if (1 == 2 - 1) {
        let {Pacifico} = await import('../fonts/Pacifico');
        doc.addFileToVFS('Pacifico-Regular.ttf', Pacifico);
        doc.addFont('Pacifico-Regular.ttf', 'Pacifico', 'normal')
        this.pdf.font1 = 'Pacifico';
      }
*/

      /*
      //doc.addFileToVFS('Scricha.ttf', Scricha);
      //doc.addFont('Scricha.ttf', 'Scricha', 'normal')
      //doc.setFont('Scricha');
      */

      //let url = "https://w7.pngwing.com/pngs/724/759/png-transparent-apple-logo-apple-computer-icons-apple-logo-heart-computer-logo.png";
      //let img = new Image();
      //img.src = url;

      /*
      this.loadImage('http://thecatapi.com/api/images/get?format=src&type=jpg&size=small')
      .then(img => document.getElementById('image-holder').appendChild(img))
      .catch(error => console.error(error));
*/
      /*
      this.loadImage('http://thecatapi.com/api/images/get?format=src&type=jpg&size=small')
    .then(img => {
      console.log(img.width, img.height)
    })
    .catch(error => console.error(error));
    */
      //doc.addImage(img, "PNG", 15, 40, 180, 180);

      this.pdf.positionY = this.pdf.marginY;
      doc.setFontSize(this.pdf.fontSizeCategoryName);
      //doc.text("LOGO", 105, this.pdf.positionY, null, null, "center");

      let deltaYCategoryName =
        (this.pdf.fontSizeCategoryName * this.pdf.lineSpacing * 25.4) / 72;
      this.pdf.positionY += deltaYCategoryName;
      //**doc.setFont(this.pdf.font1);
      doc.text(this.menu.name, 105, this.pdf.positionY, null, null, "center");

      for (let i = 0; i < this.categoriesSelected.length; i++) {
        let category = this.categoriesSelected[i];
        //doc.text(category.name, 0, positionY);
        for (let j = 0; j < category.dishes.length; j++) {
          let dish = category.dishes[j];
          this.printDish(doc, j == 0 ? category : null, dish);
        }
      }
      //let positionY = 0;
      /*
      console.log(this.categoriesSelected);
      for(let i=0; this.categoriesSelected.length; i++){
        //let category = this.categoriesSelected[i];
        console.log(this.categoriesSelected[i]);
        //doc.text(category.name, 0, positionY);
        //positionY += 30;
      }
      console.log("----------");
*/
      doc.save(pdfName + ".pdf");

      /*
console.log(this.$refs.menu.innerHTML);
    doc.fromHTML(this.$refs.menu.innerHTML, 15, 15, {
      'width': 170
    });
*/

      /*ù
       var doc = new jsPDF('p', 'pt', 'A4');
      
      let margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 522
        };
      
      //doc.text('Hello world!', 10, 10)
      
      doc.fromHTML(document.getElementById('menulist'), 15, 15, {
      'width': 170
    });
      
      doc.save('test.pdf');*/
    },
    // eslint-disable-next-line no-unused-vars
    changeCheckBox: function(event, category, dish) {
      this.askSave = true;

      if (!event.target.checked) {
        this.removeDish(category, dish);
      } else {
        this.pushCategory(category, dish);
      }
    },

    toogleAllCheckBox: function(event, category) {
      this.askSave = true;

      if (!event.target.checked) {
        for (let i = 0; i < category.dishes.length; i++) {
          this.removeDish(category, category.dishes[i]);
          const index = this.checkedDishes.indexOf(category.dishes[i].id);
          if (index > -1) {
            this.checkedDishes.splice(index, 1);
          }
        }
      } else {
        for (let i = 0; i < category.dishes.length; i++) {
          this.removeDish(category, category.dishes[i]);
          this.pushCategory(category, category.dishes[i]);

          const index = this.checkedDishes.indexOf(category.dishes[i].id);
          if (index < 0) {
            this.checkedDishes.push(category.dishes[i].id);
          }
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    pushCategory: function(category, dish) {
      let categoryFound = false;
      // eslint-disable-next-line no-unused-vars
      let categoryIndex = 0;
      for (let i = 0; i < this.categoriesSelected.length; i++) {
        if (this.categoriesSelected[i].id === category.id) {
          categoryIndex = i;
          categoryFound = true;
        }
      }
      if (!categoryFound) {
        categoryIndex = this.categoriesSelected.length;
        this.categoriesSelected.push({
          id: category.id,
          name: category.name,
          dishes: [],
          url: category.url,
        });
      }

      this.categoriesSelected[categoryIndex].dishes.push(dish);
    },

    removeDish: function(category, dish) {
      for (let i = 0; i < this.categoriesSelected.length; i++) {
        if (this.categoriesSelected[i].id === category.id) {
          for (let j = 0; j < this.categoriesSelected[i].dishes.length; j++) {
            if (this.categoriesSelected[i].dishes[j].id === dish.id) {
              this.categoriesSelected[i].dishes.splice(j, 1);
              if (this.categoriesSelected[i].dishes.length == 0) {
                this.categoriesSelected.splice(i, 1);
              }
              return;
            }
          }
        }
      }
    },

    loadImage: function(url) {
      return new Promise((resolve) => {
        let img = new Image();
        img.crossOrigin = "";

        img.onload = () => resolve(img);
        img.src = url;
      });
    },

    /*
    loadImage: function (url) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      // eslint-disable-next-line no-unused-vars
      img.addEventListener('load', e => resolve(img));
      img.addEventListener('error', () => {
        reject(new Error(`Failed to load image's URL: ${url}`));
      });
      img.src = url;
    });
    
  }*/
  },
  beforeRouteLeave(to, from, next) {
    if (this.askSave) {
      const answer = window.confirm("Salvare le modifiche?");
      if (answer) {
        this.saveMenuCompose(); // Submit your form here however you want
        next();
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>
